import PropTypes from 'prop-types';
import styles from './FJVideoRemoveBgAutoLeft.module.less';
import FJImageInputTwo from '../../../../common/components/FJImageInput/FJImageInputTwo';
import { FJVideoRemoveBgDataConfig } from '../../../../config/dataConfig/FJVideoRemoveBgDataConfig';
import FJLocalStore from '../../../../store/FJLocalStore';
import { VIDEO_AUTO_REMOVE_BG_USE_CREDIT } from '../../../../redux/slices/FJSliceVideoBgRemover';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import FJConstant from '../../../../constants/FJConstant';
import FJVideoRemoveBgRemoverAfter from './FJVideoRemoveBgRemoverAfter';
import FJVideoRemoveBgAutoExportAfterContainer from '../container/FJVideoRemoveBgAutoExportAfterContainer';
import classNames from 'classnames';

const FJVideoRemoveBgAutoLeft = ({
    uploadVideo,
    autoEditVideoIsUploading,
    uploadBeforeCallback,
    autoRemoverStatus,
    exportVideo,
    autoEditVideoInfo,
    autoExportStatus,
    isFree,
    isTrimVideo,
    removeAll,
    freeNumCreation,
    isShow,
}) => {
    return (
        <div className={classNames(styles.auto_left, { [styles.show]: isShow })}>
            <FJVerticalScroller className={classNames(styles.scroller, { [styles.trim_video]: isTrimVideo })}>
                {isShow && (
                    <FJImageInputTwo
                        uploadImg={uploadVideo}
                        isUploadVideoFile={true}
                        isLoading={autoEditVideoIsUploading}
                        disabled={
                            autoRemoverStatus === FJConstant.START ||
                            autoRemoverStatus === FJConstant.GENERATING ||
                            autoRemoverStatus === FJConstant.LOADING
                        }
                        text={'click-or-drag-to-upload-video'}
                        btnText={'upload-video'}
                        btnClassName={styles.btn}
                        smallText={FJLocalStore._('upload-video')}
                        isIconRight={true}
                        isJudgeLogin={true}
                        isSmallComponent={!!autoEditVideoInfo}
                        uploadBeforeCallback={uploadBeforeCallback}
                        acceptFile={FJVideoRemoveBgDataConfig.ACCEPT_FILE_TYPE}
                        icon={
                            <>
                                {isFree && (
                                    <div className={styles.free_tries}>
                                        {freeNumCreation === 1
                                            ? FJLocalStore._('free-trie-left')
                                            : FJLocalStore._('free-tries-left').replace('xxx', freeNumCreation)}
                                    </div>
                                )}

                                {!isFree && (
                                    <div className={styles.use_credit}>
                                        {FJLocalStore._('xxx-credits-s').replace(
                                            'xxx',
                                            VIDEO_AUTO_REMOVE_BG_USE_CREDIT,
                                        )}
                                    </div>
                                )}
                            </>
                        }
                        smallIcon={
                            <>
                                {isFree && (
                                    <div className={styles.small_free_tries}>
                                        {freeNumCreation === 1
                                            ? FJLocalStore._('free-trie-left')
                                            : FJLocalStore._('free-tries-left').replace('xxx', freeNumCreation)}
                                    </div>
                                )}
                                {!isFree && (
                                    <div className={styles.small_use_credit}>
                                        {FJLocalStore._('xxx-credits-s').replace(
                                            'xxx',
                                            VIDEO_AUTO_REMOVE_BG_USE_CREDIT,
                                        )}
                                    </div>
                                )}
                            </>
                        }
                    />
                )}

                {autoRemoverStatus !== FJConstant.DEFAULT && (
                    <FJVideoRemoveBgRemoverAfter
                        isTrimVideo={isTrimVideo}
                        exportVideo={exportVideo}
                        removeAll={removeAll}
                        disabled={autoRemoverStatus !== FJConstant.SUCCESS}
                        isShowHeader={false}
                        isShow={true}
                    />
                )}

                {autoExportStatus !== FJConstant.DEFAULT && <FJVideoRemoveBgAutoExportAfterContainer />}
            </FJVerticalScroller>
        </div>
    );
};

FJVideoRemoveBgAutoLeft.propTypes = {
    uploadVideo: PropTypes.func,
    autoEditVideoIsUploading: PropTypes.bool,
    uploadBeforeCallback: PropTypes.func,
    autoRemoverStatus: PropTypes.string,
    exportVideo: PropTypes.func,
    autoEditVideoInfo: PropTypes.object,
    autoExportStatus: PropTypes.string,
    isFree: PropTypes.bool,
    freeNumCreation: PropTypes.number,
    isTrimVideo: PropTypes.bool,
    removeAll: PropTypes.func,
    isShow: PropTypes.bool,
};
export default FJVideoRemoveBgAutoLeft;
